import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Playlist } from '@model/playlist';
import { TunifyCheckBoxColor } from '../../../../components-v5/checkbox-v5/checkbox-v5.component';

@Component({
    selector: 'tun-overlay-playlist-button-view',
    templateUrl: './overlay-playlist-button-view.component.html',
    styleUrls: ['./overlay-playlist-button-view.component.scss'],
    standalone: false
})
export class OverlayPlaylistButtonViewComponent {

  @Input() title: string;
  @Input() subTitleOnHover: string;

  @Input() isFavorite = false;
  @Input() isQueue = false;

  @Output() select = new EventEmitter<void>();

  public TunifyCheckBoxColor = TunifyCheckBoxColor

  constructor(

  ){

  }

  public onSelect(){
    this.select.emit();
  }
}
